<ion-content class="table-content">
  <app-dashboard-header (onSelected)="toggleFilterBody($event)" [filterComps]="filterComps" [filterObject]="filterObject"
                        [headerSetting]="headerSetting" [searchField]="searchField"
                        [showFilterBody]="showFilterBody"></app-dashboard-header>
  <div class="tabs-wrap">
    <div class="tabs">
      <div (click)="toggle(tab)" *ngFor="let tab of tabs" [ngClass]="{'active-tab': tab.selected}" class="tab">
        {{tab.name}}<span class="tab-select-count">({{tab.count}})</span>
      </div>
    </div>
  </div>

  <div [hidden]="!(preSelected.id=='processSubmitted')" class="table-container">
    <table class="display" id="processSubmitted"></table>
  </div>
  <div [hidden]="!(preSelected.id=='processAssigned')" class="table-container">
    <table class="display" id="processAssigned"></table>
  </div>
  <div [hidden]="!(preSelected.id=='processImplemented')" class="table-container">
    <table class="display" id="processImplemented">
    </table>
  </div>

  <div [hidden]="!(preSelected.id=='processClosed')" class="table-container">
    <table class="display" id="processClosed">
    </table>
  </div>
</ion-content>
